import script from "./NotarialActionSign.vue?vue&type=script&setup=true&lang=js"
export * from "./NotarialActionSign.vue?vue&type=script&setup=true&lang=js"

import "./NotarialActionSign.vue?vue&type=style&index=0&id=0db19747&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0db19747"]])

export default __exports__